// European Union Country Codes

const EUCountries = {
  BE: 'Belgium',
  BG: 'Bulgaria',
  CZ: 'Czech Republic',
  DK: 'Denmark',
  DE: 'Germany',
  EE: 'Estonia',
  IE: 'Ireland',
  GR: 'Greece',
  ES: 'Spain',
  FR: 'France',
  HR: 'Croatia',
  IT: 'Italy',
  CY: 'Cyprus',
  LV: 'Latvia',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  HU: 'Hungary',
  MT: 'Malta',
  NL: 'Netherlands',
  AT: 'Austria',
  PL: 'Poland',
  PT: 'Portugal',
  RO: 'Romania',
  SI: 'Slovenia',
  SK: 'Slovakia',
  FI: 'Finland',
  SE: 'Sweden',
}

export type EUCountryCode = keyof typeof EUCountries
export const EUCountryCodes: EUCountryCode[] = Object.keys(EUCountries) as EUCountryCode[]

export const isCountryEU = (countryCode?: string): boolean => {
  if (!countryCode) {
    return false
  }
  return (EUCountryCodes as string[]).includes(countryCode)
}
